/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

const mediaManageRouter = {
  path: '/media-manage',
  component: Layout,
  redirect: '/media-manage/third-tag-mapping',
  name: 'MediaManage',
  alwaysShow: true,
  meta: {
    title: 'mediaManage',
    icon: 'documentation'
  },
  children: [
    {
      path: 'third-tag-mapping',
      component: () => import('@/views/media-manage/third-tag-mapping'),
      name: 'ThirdTagMapping',
      meta: { title: 'ThirdTagMapping', noCache: false }
    },
    {
      path: 'channel-region-risk-rule',
      component: () => import('@/views/media-manage/channel-region-risk-rule'),
      name: 'ChannelRegionRiskRule',
      meta: { title: 'ChannelRegionRiskRule', noCache: false }
    }
  ]
}

export default mediaManageRouter
